import React, { useEffect } from 'react';
import { initMetaPixel } from './utils/metaPixel';
import { Hero } from './components/Hero';
import { SocialProof } from './components/SocialProof';
import { WhatYouGet } from './components/WhatYouGet';
import { Benefits } from './components/Benefits';
import { FaqSection } from './components/FaqSection';
import { InstantAccess } from './components/InstantAccess';
import { Guarantee } from './components/Guarantee';
import { FinalCta } from './components/FinalCta';
import { SiteFooter } from './components/SiteFooter';
interface AppProps {
  /** Show the limited-offer countdown block under the What You Get CTA. */
  showUrgencyBanner?: boolean;
  /** Full-bleed stadium hero, or a split hero led by the product bundle. */
  heroVariant?: 'stadium' | 'bundle';
}
export function App({
  showUrgencyBanner = true,
  heroVariant = 'stadium'
}: AppProps) {
  useEffect(() => {
    // Load the tracking pixel only once the page is interactive, so it never
    // competes with the first paint.
    const idle = (window as typeof window & {
      requestIdleCallback?: (cb: () => void, opts?: {
        timeout: number;
      }) => number;
    }).requestIdleCallback;
    if (idle) {
      idle(() => initMetaPixel(), {
        timeout: 3000
      });
      return;
    }
    const id = window.setTimeout(initMetaPixel, 1200);
    return () => window.clearTimeout(id);
  }, []);
  return <div className="w-full bg-navy-950 font-sans" data-id="element-0" data-mp="2zlv6ktmtuzuj">
      <main data-id="element-1" data-mp="2zn6b4vo3kbmp">
        <Hero variant={heroVariant} data-id="element-2" data-mp="2znfyebhrc4op" />
        <SocialProof data-id="element-3" data-mp="33lx0ggmbmoz9" />
        <WhatYouGet data-id="element-4" data-mp="33n6zb810016y" />
        <FinalCta data-id="element-5" data-mp="33orjq4tlm3r3" />
        <Benefits data-id="element-6" data-mp="38lrqkhy9vaj9" />
        <FaqSection data-id="element-7" data-mp="38l8h7pmotugu" />
        <InstantAccess showUrgency={showUrgencyBanner} data-id="element-8" data-mp="38kqgafp2ys2l" />
        <Guarantee data-id="element-9" data-mp="3dkuvm2e95gr8" />
      </main>
      <SiteFooter data-id="element-10" data-mp="3dlw6o6v9q38y" />
    </div>;
}